'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pipe = require('./pipe');

var _pipe2 = _interopRequireDefault(_pipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (item) {
  for (var _len = arguments.length, funcs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    funcs[_key - 1] = arguments[_key];
  }

  return _pipe2.default.apply(undefined, funcs)(item);
};


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/util/pipeWith.js
// module id = 11
// module chunks = 35783957827783